export const DATETIME_FORMAT = "yyyy-MM-dd HH:mm:ss";
export const DATETIME_DISPLAY_FORMAT = "yyyy-MM-dd HH:mm";

export const DATE_FORMAT = "yyyy-MM-dd";
export const DATE_DISPLAY_FORMAT = "yyyy-MM-dd"; 